export default "__VITE_ASSET__OSTQ5CKs__"